import { render, staticRenderFns } from "./AddNotification.vue?vue&type=template&id=468c582e&scoped=true&"
import script from "./AddNotification.vue?vue&type=script&lang=js&"
export * from "./AddNotification.vue?vue&type=script&lang=js&"
import style0 from "./AddNotification.vue?vue&type=style&index=0&id=468c582e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468c582e",
  null
  
)

export default component.exports